export function getAllEconomies(axiosPrivate) {
  return axiosPrivate.get('/economies')
}

export function getEconomyByIso3(axiosPrivate, iso3) {
  return axiosPrivate.get(`/economies/${iso3}`)
}

export function createEconomy(axiosPrivate, data) {
  return axiosPrivate.post('/economies', data)
}

export function updateEconomy(axiosPrivate, iso3, data) {
  return axiosPrivate.put(`/economies/${iso3}`, data)
}

export function deleteEconomy(axiosPrivate, iso3) {
  return axiosPrivate.delete(`/economies/${iso3}`)
}
